import * as tslib_1 from "tslib";
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Text } from "./Text";
import PropTypes from "prop-types";
import { MenuLabel } from "./Menu";
import { useTheme } from "./Theme/Providers";
import { noOp } from "./misc/noop";
import { useTouchable } from "touchable-hook";
import { safeBind } from "./Hooks/compose-bind";
export var List = function (_a) {
    var children = _a.children, other = tslib_1.__rest(_a, ["children"]);
    return jsx("nav", tslib_1.__assign({}, other), children);
};
List.propTypes = {
    children: PropTypes.node
};
export var ListItem = function (_a) {
    var _b;
    var primary = _a.primary, secondary = _a.secondary, contentBefore = _a.contentBefore, _c = _a.interactive, interactive = _c === void 0 ? true : _c, children = _a.children, _d = _a.wrap, wrap = _d === void 0 ? true : _d, contentAfter = _a.contentAfter, _e = _a.onPress, onPress = _e === void 0 ? noOp : _e, _f = _a.component, Component = _f === void 0 ? "div" : _f, other = tslib_1.__rest(_a, ["primary", "secondary", "contentBefore", "interactive", "children", "wrap", "contentAfter", "onPress", "component"]);
    var interactiveProps = interactive
        ? {
            role: "button",
            tabIndex: 0
        }
        : {};
    var isLink = other.to || other.href;
    var _g = useTouchable({
        onPress: onPress,
        behavior: isLink ? "link" : "button"
    }), bind = _g.bind, hover = _g.hover, active = _g.active;
    var theme = useTheme();
    return (jsx(Component, tslib_1.__assign({ className: "ListItem", css: [
            (_b = {
                    display: "block",
                    textDecoration: "none",
                    outline: "none",
                    padding: theme.spaces.md,
                    background: "transparent",
                    WebkitTapHighlightColor: "transparent",
                    transition: "background 0.07s ease"
                },
                _b[theme.mediaQueries.md] = {
                    paddingLeft: theme.spaces.lg,
                    paddingRight: theme.spaces.lg
                },
                _b[":last-child"] = {
                    borderBottom: "none"
                },
                _b),
            interactive && {
                cursor: "pointer",
                ":focus": {
                    boxShadow: "inset 0 0 3px " + theme.colors.text.selected
                },
                ":focus:not([data-focus-visible-added])": {
                    boxShadow: "none"
                }
            },
            interactive &&
                hover && {
                background: theme.colors.background.tint1
            },
            interactive &&
                active && {
                background: theme.colors.background.tint2
            }
        ] }, interactiveProps, safeBind(interactive ? bind : {}, other)),
        jsx("div", { className: "ListItem__container", css: { display: "flex", alignItems: "center" } },
            contentBefore && (jsx("div", { className: "ListItem__content-before", css: { marginRight: theme.spaces.md } }, contentBefore)),
            jsx("div", { className: "ListItem__content", css: { flex: 1, overflow: "hidden" } },
                jsx(Text, { className: "ListItem__primary", wrap: wrap, variant: "body", css: { display: "block", fontWeight: 500 } }, primary),
                secondary && (jsx(Text, { className: "ListItem__secondary", wrap: wrap, css: { display: "block", fontSize: theme.fontSizes[0] }, variant: "body", muted: true }, secondary)),
                children),
            contentAfter && (jsx("div", { className: "ListItem__content-after", css: { flex: "0 0 auto", marginLeft: theme.spaces.md } }, contentAfter)))));
};
ListItem.propTypes = {
    primary: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    secondary: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    contentBefore: PropTypes.node,
    contentAfter: PropTypes.node,
    wrap: PropTypes.bool,
    children: PropTypes.node,
    interactive: PropTypes.bool,
    onPress: PropTypes.func,
    component: PropTypes.elementType
};
export var ListSection = function (_a) {
    var _b;
    var title = _a.title, children = _a.children, _c = _a.sticky, sticky = _c === void 0 ? true : _c, other = tslib_1.__rest(_a, ["title", "children", "sticky"]);
    var theme = useTheme();
    var bg = theme.colors.background.layer;
    return (jsx("div", { css: {
            ":first-child > *": {
                borderTop: "none"
            }
        } },
        jsx(MenuLabel, tslib_1.__assign({ css: (_b = {
                    position: sticky ? "sticky" : "static",
                    top: 0,
                    backgroundColor: sticky ? bg : "transparent",
                    padding: theme.spaces.sm,
                    paddingLeft: theme.spaces.md,
                    marginTop: theme.spaces.md
                },
                _b[theme.mediaQueries.md] = {
                    paddingLeft: theme.spaces.lg,
                    paddingRight: theme.spaces.lg
                },
                _b) }, other), title),
        children));
};
ListSection.propTypes = {
    title: PropTypes.string.isRequired,
    sticky: PropTypes.bool,
    children: PropTypes.node
};
